import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, remove, scrollInfo } from 'kapix-components-vue3'
import formationsUiUxDesignStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'formationsUiUxDesign'
const customImplement: CustomStoreImplementationOptions = formationsUiUxDesignStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function formationsUiUxDesignFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('prog-10-ui-ux-design.title', 'Formation UI/UX sur-mesure'),
        $description: $translate('prog-10-ui-ux-design.description', 'Nos experts en UI/UX vous font monter en compétences tout au long de votre projet. Formation avec 0 reste à charge pour vous ! '),
        $publishedTime: new Date('2023-03-24T09:53:48.166Z'),
        $modifiedTime: new Date('2023-07-28T08:07:32.690Z'),
        // Constants,
        $constants: {
          dropDownFormationArguments: [
            { Text: '<ul><li>Connaître les grandes tendances comportementales à l’ère du digital.</li></ul>' },
            { Text: '<ul><li>Maîtriser les principes de l’ergonomie et de l’UX design.</li></ul>' },
            { Text: '<ul><li>Comprendre les facteurs clés d’une ergonomie réussie.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element4Arguments: [
            { Text: '<ul><li>Assimiler la définition d’une charte de navigation.</li></ul>' },
            { Text: '<ul><li>Appliquer les bons effets graphiques : couleurs, formes, influences.</li></ul>' },
            { Text: '<ul><li>Utiliser la méthode des personas pour adapter son interface à ses clients.</li></ul>' },
            { Text: '<ul><li>Savoir définir des user stories par cible.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element5Arguments: [
            { Text: '<ul><li>Structurer et hiérarchiser les informations.</li></ul>' },
            { Text: '<ul><li>Employer les règles de nommage.&nbsp;</li></ul>' },
            { Text: '<ul><li>Comprendre les facteurs clés d’une ergonomie réussie.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element6Arguments: [
            { Text: '<ul><li>Assimiler la définition d’une charte de navigation.</li></ul>' },
            { Text: '<ul><li>Appliquer les bons effets graphiques : couleurs, formes, influences.</li></ul>' },
            { Text: '<ul><li>Utiliser la méthode des personas pour adapter son interface à ses clients.</li></ul>' },
            { Text: '<ul><li>Savoir définir des user stories par cible.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element7Arguments: [
            { Text: '<ul><li>Faire tester sa maquette à un groupe d’utilisateurs.</li></ul>' },
            { Text: '<ul><li>Capter les axes d’amélioration et optimiser ses interfaces.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>
        },
        // Data,
        $info: { prog10UiUxDesign: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return formationsUiUxDesignFactory(storeId)()
}

export const formationsUiUxDesignRaw = formationsUiUxDesignFactory()
export const formationsUiUxDesign = () => formationsUiUxDesignRaw() as MergeCustomStore<typeof formationsUiUxDesignStoreCustom.instance>
